import React from "react";
import PropTypes from "prop-types";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import { Button, ButtonGroup, Card, CardContent } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import CreateLocal from "./Modals/CreateLocal";
import DeleteLocal from "./Modals/DeleteLocal";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  {
    id: "name",
    numeric: false,
    disablePadding: false,
    label: "Local",
  },
  {
    id: "address",
    numeric: false,
    disablePadding: false,
    label: "Dirección",
  },
  {
    id: "suscriptionName",
    numeric: false,
    disablePadding: false,
    label: "Suscripción",
  },
  {
    id: "isALU",
    numeric: false,
    disablePadding: false,
    label: "Es ALU",
  },
  {
    id: "isALN",
    numeric: false,
    disablePadding: false,
    label: "Es ALN",
  },
  { id: "options", numeric: false, disablePadding: false, label: "Opciones" },
];

function EnhancedTableHead(props) {
  const { classes, order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "default"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
}));

export default function EnhancedTable({ locals, customerId, updateLocals }) {
  const classes = useStyles();
  const [order, setOrder] = React.useState("desc");
  const [orderBy, setOrderBy] = React.useState("datetimeRequest");
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(7);
  const [rows, setRows] = React.useState([]);

  const [showLocalModal, setShowLocalModal] = React.useState(false);
  const [selectedLocal, setSelectedLocal] = React.useState(null);
  const [showDeleteModal, setShowDeleteModal] = React.useState(false);
  const [localToDelete, setLocalToDelete] = React.useState(null);

  React.useEffect(() => {
    if (locals) {
      setRows(locals);
    }
  }, [locals]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = rows.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

  return (
    <>
      <Card>
        <CardContent>
          <h4 style={{ textAlign: "center" }}>Lista de locales</h4>
          <div style={{display: "flex", flexDirection: "row-reverse"}}>
              <Button
                  onClick={() => {
                    setSelectedLocal(null);
                    setShowLocalModal(true);
                  }}
                  color="primary"
                  size="small"
                  variant="contained"
                  startIcon={<AddCircleOutlineIcon />}
              >
                  Registrar local
              </Button>
          </div>
          <br></br>
          <div className={classes.root}>
            <TableContainer>
              <Table
                className={classes.table}
                size="small"
                aria-labelledby="tableTitle"
                aria-label="enhanced table"
              >
                <EnhancedTableHead
                  classes={classes}
                  numSelected={selected.length}
                  order={order}
                  orderBy={orderBy}
                  onSelectAllClick={handleSelectAllClick}
                  onRequestSort={handleRequestSort}
                  rowCount={rows.length}
                />
                <TableBody>
                  {stableSort(rows, getComparator(order, orderBy))
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => {
                      const isItemSelected = isSelected(index);

                      return (
                        <TableRow
                          hover
                          tabIndex={-1}
                          key={index}
                          selected={isItemSelected}
                        >
                          <StyledTableCell align="left">
                            {row.name}
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            {row.address}
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            {row.suscriptionName}
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            {row.isAlu ? "Sí" : "No"}
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            {row.isAln ? "Sí" : "No"}
                          </StyledTableCell>
                          <StyledTableCell align="right">
                              <ButtonGroup size="small" variant="contained">
                                  <Button
                                  onClick={() => {
                                    setSelectedLocal(row);
                                    setShowLocalModal(true);
                                  }}
                                  startIcon={<EditIcon />}
                                  >
                                  ver y editar
                                  </Button>
                                  <Button
                                  onClick={() => {
                                    setLocalToDelete(row);
                                    setShowDeleteModal(true);
                                  }}
                                  color="primary"
                                  >
                                  <DeleteIcon />
                                  </Button>
                              </ButtonGroup>
                          </StyledTableCell>
                        </TableRow>
                      );
                    })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: (dense ? 33 : 53) * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>
              </Table>
              {rows.length ? (
                ""
              ) : (
                <h4 style={{ margin: 24 }}>No se encontraron resultados</h4>
              )}
            </TableContainer>
            <TablePagination
              labelRowsPerPage={"Filas por página"}
              labelDisplayedRows={({ from, to, count }) =>
                `${from}-${to === -1 ? count : to} de ${
                  count !== -1 ? count : `más de ${to}`
                }`
              }
              rowsPerPageOptions={[7, 14, 25]}
              component="div"
              count={rows.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
            />
          </div>
        </CardContent>
      </Card>

      <CreateLocal
        customerId={customerId}
        show={showLocalModal}
        setShow={setShowLocalModal}
        updateLocals={updateLocals}
        local={selectedLocal}
        locals={rows}
      />

      <DeleteLocal
        customerId={customerId}
        show={showDeleteModal}
        setShow={setShowDeleteModal}
        local={localToDelete}
        locals={rows}
        updateLocals={updateLocals}
      />
    </>
    
  );
}
